module.exports = __webpack_public_path__ + "img/13.35c008ac.png";